import * as React from 'react'

import { observer } from 'mobx-react'

interface Props {
  src: string
}

const Image = ({ src }: Props) => {
  return <img src={src} />
}

export default observer(Image)
